import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { EFFY_FUEL_PRODUCT } from './products/effyFuelContent';
import './PublicNavbar.css';

export default function PublicNavbar() {
  const { user } = useAuth();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const getLogoLink = () => {
    if (!user) return "/";
    return user.adminUser ? "/products/order-tracking/admin/users" : "/products/order-tracking/dashboard";
  };

  const isProductsActive = (location.pathname.startsWith('/products') &&
    !location.pathname.startsWith('/products/order-tracking')) ||
    location.pathname === '/products/effy-order';
  return (
    <nav className={`pub-nav ${scrolled ? 'pub-nav--scrolled' : ''} ${menuOpen ? 'pub-nav--open' : ''}`}>
      <div className="pub-nav__inner">
        <Link to={getLogoLink()} className="pub-nav__logo">
          <img src="/logo/logo-icon.svg" className="pub-nav__logo-img" alt="EffyVenture logo" />
          <span className="pub-nav__logo-text">
            <span className="pub-nav__logo-effy">Effy</span><span className="pub-nav__logo-venture">Venture</span>
          </span>
        </Link>

        <button
          className={`pub-nav__hamburger ${menuOpen ? 'pub-nav__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span className="pub-nav__hamburger-bar" />
          <span className="pub-nav__hamburger-bar" />
          <span className="pub-nav__hamburger-bar" />
        </button>

        <div className={`pub-nav__links ${menuOpen ? 'pub-nav__links--open' : ''}`}>
          <Link
            to="/"
            className={`pub-nav__link ${location.pathname === '/' ? 'pub-nav__link--active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>

          <div className="pub-nav__dropdown">
            <span className={`pub-nav__link pub-nav__dropdown-trigger ${isProductsActive ? 'pub-nav__link--active' : ''}`}>
              Products <span className="pub-nav__dropdown-caret">▾</span>
            </span>
            <div className="pub-nav__dropdown-menu">
              <Link to="/products/effy-order" className="pub-nav__dropdown-item" onClick={() => setMenuOpen(false)}>
                Effy Order
              </Link>
              {/* Each product's own pages sit indented under it, so future products get their own group */}
              <Link to="/products/effy-order/features" className="pub-nav__dropdown-item pub-nav__dropdown-item--sub" onClick={() => setMenuOpen(false)}>
                All features
              </Link>
              <Link to={EFFY_FUEL_PRODUCT.path} className="pub-nav__dropdown-item" onClick={() => setMenuOpen(false)}>
                {EFFY_FUEL_PRODUCT.name}
              </Link>
              <Link to={EFFY_FUEL_PRODUCT.featuresPath} className="pub-nav__dropdown-item pub-nav__dropdown-item--sub" onClick={() => setMenuOpen(false)}>
                All features
              </Link>
            </div>
          </div>

          <div className="pub-nav__dropdown">
            <span className={`pub-nav__link pub-nav__dropdown-trigger ${location.pathname === '/effy-order-pricing' ? 'pub-nav__link--active' : ''}`}>
              Pricing <span className="pub-nav__dropdown-caret">▾</span>
            </span>
            <div className="pub-nav__dropdown-menu">
              <Link to="/effy-order-pricing" className="pub-nav__dropdown-item" onClick={() => setMenuOpen(false)}>
                Effy Order
              </Link>
            </div>
          </div>

          <Link
            to="/contact"
            className={`pub-nav__link ${location.pathname === '/contact' ? 'pub-nav__link--active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
}
